const COLORS = [
  '#2563EB', '#0891B2', '#059669', '#7C3AED',
  '#DC2626', '#D97706', '#BE185D', '#0369A1',
  '#047857', '#6D28D9', '#B45309', '#0E7490',
];

const BRAND_COLORS_KEY = 'gormaran_brand_colors';

export function loadBrandColors() {
  try { return JSON.parse(localStorage.getItem(BRAND_COLORS_KEY) || '{}'); } catch { return {}; }
}

export function saveBrandColor(clientId, color) {
  const all = loadBrandColors();
  all[clientId] = color;
  try { localStorage.setItem(BRAND_COLORS_KEY, JSON.stringify(all)); } catch {}
}

export function avatarColor(name) {
  let hash = 0;
  for (let i = 0; i < (name || '').length; i++) hash = (hash * 31 + (name || '').charCodeAt(i)) >>> 0;
  return COLORS[hash % COLORS.length];
}

/**
 * Single source of truth for client color across all components.
 * Priority: user-chosen (brandColors) → stored client.color → hash-based fallback
 */
export function getClientColor(client, brandColors = {}) {
  return brandColors[client.id] || client.color || avatarColor(client.name || client.company);
}
